
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import useTranslation from 'next-translate/useTranslation';
import LockedMETContextProvider from '../../../components/LockedMetContext';
import LockedPositionsList from '../../../components/LockedPositionsList';
import LockedPositionsSummary from '../../../components/LockedPositionsSummary';
import LockMetNavigation from '../../../components/LockMetNavigation';
import Page from '../../../components/Page';
import getServerSideProps from '../../../utils/esMetServerProps';
export default function LockedMET({ hasError, initialEsMetInfoData }) {
    const { t } = useTranslation();
    return (<LockedMETContextProvider initialEsMetInfoData={initialEsMetInfoData}>
      <Page hasError={hasError} title={t('navigation.lockmet')}>
        <h2 className="mb-4 mt-4 text-2xl font-semibold leading-7 text-white">
          {t('lock')}
        </h2>
        <p className="mb-8 text-gray-500">{t('lock-page-description')}</p>
        <LockMetNavigation />
        <LockedPositionsSummary />
        <LockedPositionsList />
      </Page>
    </LockedMETContextProvider>);
}
export {};

    async function __Next_Translate__getServerSideProps__1a0f35fc59c__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/[shortName]/lock-met/positions',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a0f35fc59c__ as getServerSideProps }
  